import { useAuth } from "./useAuth";

export type SubscriptionPlan = "free" | "pro_solo" | "pro_growth";

function hasActivePaidEntitlement(status?: string | null, validUntil?: string | null): boolean {
  const normalizedStatus = status?.toLowerCase();
  if (normalizedStatus !== "active" && normalizedStatus !== "pro" && normalizedStatus !== "grace") {
    return false;
  }
  if (!validUntil) return true;
  const expiresAt = new Date(validUntil);
  if (Number.isNaN(expiresAt.getTime())) return true;
  return Date.now() <= expiresAt.getTime() + 24 * 60 * 60 * 1000;
}

export function useSubscriptionPlan(): SubscriptionPlan {
  const { profile, isFounder } = useAuth();
  if (isFounder || profile?.is_vip) return "pro_growth"; // Founder and VIP get full access
  const plan = profile?.subscription_plan;
  if ((plan === "pro_solo" || plan === "pro_growth") && hasActivePaidEntitlement(profile?.subscription_status, profile?.subscription_valid_until)) {
    return plan;
  }
  return "free";
}

export const FREE_PRODUCT_LIMIT = 5;
export const FREE_HISTORY_DAYS = 30;
export const PRO_SOLO_BRANCH_LIMIT = 1;
export const PRO_GROWTH_BRANCH_LIMIT = 3;
